import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@common/services/authentication/auth.service';

import { DroppableEnpsComponent } from './droppable-enps-component';

@Component({
    template: '',
})
export class EnpsRouterComponent extends DroppableEnpsComponent implements AfterViewInit, OnDestroy {
    public authService: AuthService;

    constructor(
        authService: AuthService,
        protected activatedRoute: ActivatedRoute
    ) {
        super();
        this.authService = authService;
    }

    ngAfterViewInit() {
        super.createSubscription(this.activatedRoute.params, this.routeChanged.bind(this));
        if (this.authService.shouldReload) {
            location.reload();
        }
    }

    protected routeChanged() {}
}
